import { render, staticRenderFns } from "./TeacherModal.vue?vue&type=template&id=7c978b1a&scoped=true"
import script from "./TeacherModal.vue?vue&type=script&lang=js"
export * from "./TeacherModal.vue?vue&type=script&lang=js"
import style0 from "./TeacherModal.vue?vue&type=style&index=0&id=7c978b1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c978b1a",
  null
  
)

export default component.exports